import { z } from 'zod';
import { dataGridSearchFields } from '@/features/dynamic-table';
import { FilterKey, TabKey } from './-constants';
import { WORKFORCE_SORT_COLUMNS } from './-utils/isWorkforceSortColumn';
export const SearchSchema = z.object({
  ...dataGridSearchFields,
  // 未知のキーは捨てて未ソートで開く。そのまま通すと BE が解決できず 400 になる。
  sortColumn: z.enum(WORKFORCE_SORT_COLUMNS).optional().catch(undefined),
  menu: z.nativeEnum(TabKey).default(TabKey.EMPLOYEE),
  category: z.nativeEnum(FilterKey).default(FilterKey.EMPLOYEE_ALL),
  departmentIdIn: z.array(z.string()).optional(),
  workerTypeIn: z.array(z.string()).optional(),
  placeIdIn: z.array(z.string()).optional(),
  leaveOfAbsenceTypeIdIn: z.array(z.string()).optional(),
  freeText: z.string().optional()
});
export type SearchSchema = z.infer<typeof SearchSchema>;